import React from 'react';
import { ListboxButton } from '@headlessui/react';
import { ChevronDownIcon as ArrowIcon } from '@heroicons/react/24/solid';
import { classnames } from '@/utils/classnames/classnames';
import useClassNames from '../../hooks/useClassNames';
import { useDropdown } from '../../context';
import { Props } from './types';

const DropdownButton = ({ children, className }: Props) => {
  const { disabled, size, value, defaultValue } = useDropdown();

  const { buttonClassName } = useClassNames({ disabled, size });

  return (
    <ListboxButton data-testid="dropdown-button" className={classnames(className, buttonClassName)}>
      {({ open }) => (
        <div className="relative w-full">
          <div className="block truncate pr-7">
            {typeof children === 'function'
              ? children({ selected: { value: value ?? defaultValue }, isExpanded: open })
              : children}
          </div>
          <span className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
            <ArrowIcon className="h-[18px]" aria-hidden="true" />
          </span>
        </div>
      )}
    </ListboxButton>
  );
};

export default DropdownButton;
